<script setup>

import {useRoute} from "vue-router";
import {watch, ref, onBeforeUnmount} from "vue";
import OpenHpoMutation from "@/graphql/mutations/hpo/openHpoMutation.graphql";
import {useMutation} from "@vue/apollo-composable";
import HpoDashboard from "@/components/hpo/dashboard/HpoDashboard.vue";
import {mdiCloseCircle} from "@mdi/js";
import {useTitle} from "@/utils/metadata";
import {currentUser} from "@/infrastructure/user";
import {Permissions} from "@/infrastructure/permissions";
import {clearGraphQLHeaders, setGraphQLHeaders} from "@/graphql/client";

const OPEN_OK = 'ok';
const OPEN_VALIDATE = 'validate';
const OPEN_LOGIN = 'login';

const hpo = ref(null);
const hpoMember = ref(null);
const countries = ref(null);
const memberId = ref(null);

const route = useRoute();
const {mutate: openHpo, loading} = useMutation(OpenHpoMutation);

watch(
    () => route.params.id,
    (id) => {
        if ((currentUser.hasPermission(Permissions.HPO__MEMBER_TYPE_SWITCH) || currentUser.isSuperuser) && route.query.memberId) {
            memberId.value = route.query.memberId;
            setGraphQLHeaders({
                'X-Eodsun-HPO-Member-Id': memberId.value.toString(),
            });
        }

        openHpo({hpoId: id})
            .then((response) => {
                const data = response.data.openHpoMutation;
                switch (data.status) {
                    case OPEN_OK:
                        hpo.value = data.hpo;
                        hpoMember.value = data.hpoMember;
                        countries.value = data.countries;
                        break;

                    case OPEN_VALIDATE:
                        document.location = reverseUrl('web:hpo:sign_in_validate');
                        break;

                    case OPEN_LOGIN:
                        document.location = reverseUrl('web:account:login');
                        break;
                }
            });
    },
    {immediate: true}
)

useTitle(() => {
    if (!hpo.value) {
        return gettext('Loading HPO');
    }
    return `HPO ${hpo.value.name}`;
});

onBeforeUnmount(() => {
    clearGraphQLHeaders();
});
</script>

<template>
    <v-empty-state v-if="loading">
        <template #media>
            <v-progress-circular indeterminate :size="48" :width="6" color="green"/>
        </template>
        <template #title>
            {{ gettext('Loading HPO') }}
        </template>
    </v-empty-state>
    <HpoDashboard v-else-if="hpo" :hpo="hpo" :member="hpoMember" :countries="countries"/>
    <v-empty-state v-else :icon="mdiCloseCircle"
                   color="red"
                   :title="pgettext('title', 'Error while loading HPO data. Please try again later.')"/>
</template>
